export default __webpack_public_path__ + "img/equipments-expert-banner.asset.f62434b6.png";